module.exports = __webpack_public_path__ + "img/bg_xdyl.c9724807.svg";